import { useEffect, useState } from 'react';
import axios from 'axios';
import { DASH, authHeader } from '../api';
import { SectionCard, Spinner, EmptyState, fmtMoney, fmtDate } from '../ui';

const CustomersSection = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${DASH}/customers`, { headers: authHeader() })
      .then((res) => mounted && setRows(res.data || []))
      .catch(() => mounted && setError('Could not load customers.'))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  if (loading) return <Spinner label="Loading customers…" />;

  return (
    <div data-testid="wellness-admin-section-customers" className="space-y-4">
      <div>
        <h2 className="text-2xl tracking-tight" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, color: '#0d1f15' }}>
          Customers
        </h2>
        <p className="text-sm text-[#5a7062] mt-1">Everyone with a Wellness Club account.</p>
      </div>
      {error && <div className="text-sm text-red-700">{error}</div>}
      <SectionCard testId="customers-card">
        {rows.length === 0 ? (
          <EmptyState testId="customers-empty" label="No customer accounts yet." />
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[11px] uppercase tracking-wide text-[#5a7062] border-b border-[#f0ebe0]">
                  <th className="py-2 pr-4">Name</th>
                  <th className="py-2 pr-4">Email</th>
                  <th className="py-2 pr-4">Visits</th>
                  <th className="py-2 pr-4">Total Spend</th>
                  <th className="py-2 pr-4">Last Login</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((c) => (
                  <tr key={c.id} data-testid={`customer-row-${c.id}`} className="border-b border-[#f6f4ef] last:border-0">
                    <td className="py-3 pr-4 font-semibold text-[#0d1f15]">{c.first_name || '—'}</td>
                    <td className="py-3 pr-4">{c.email}</td>
                    <td className="py-3 pr-4">{c.visits}</td>
                    <td className="py-3 pr-4">{fmtMoney(c.total_spend)}</td>
                    <td className="py-3 pr-4">{fmtDate(c.last_login_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SectionCard>
    </div>
  );
};

export default CustomersSection;
